<template>
    <div>
        <div class="page-top mb-1 mb-3">
            <h1> Add FAQ Category</h1>
        </div>
        <div class="global-main">
            <form id="cityForm" @submit.prevent="addFaqCategory">
                <div class="tab-content-inner">
                    <div class="form-group">
                        <label> Name </label>
                        <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                        <has-error :form="form" field="name"></has-error>
                    </div>
                </div>
                <div class="form-group">
                    <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                    <router-link to="/faqsCategory" class="btn btn-primary float-right mr-2">Cancel</router-link>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    name : '',
                }),
            }
        },
        methods: {
            addFaqCategory() {
                this.$Progress.start();
                this.form.post('api/addFaqCategoryAPI')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','FAQ Category created successfully');
                        this.$router.push('/faqsCategory');
                    }else{
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            },
        },
        created() {

        },
    }
</script>
